// extracted by mini-css-extract-plugin
export default {"themeReminderBanner":"themeReminderBanner___TKCUt","themeReminderText":"themeReminderText___qs6Kk","themeReminderBtn":"themeReminderBtn___NZ_6I"};